import { render, staticRenderFns } from "./plan-discount.vue?vue&type=template&id=e40a380c"
import script from "./plan-discount.vue?vue&type=script&lang=js"
export * from "./plan-discount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports